module.exports = __webpack_public_path__ + "static/media/PNG-AVAX.7f9935bd.svg";